.tableBody {
  display: block;
}
